export default __webpack_public_path__ + "static/media/LAS0600.34I-30411_-17570_0.76789465.jpg";